import React, { useCallback, useMemo } from "react";
import useDocumentDetailTable from "./DocumentDetailTable.hook.js";
import DataTables from "../../../../../components/Datatables/datatables.js";
import styles from "./Style.module.css";
import StatusPill from "../../../../../components/Status/StatusPill.component.js";
import classNames from "classnames";
import Constants from "../../../../../config/constants.js";
import FilterComponent from "../../../../../components/Filter/Filter.component.js";
import { removeUnderScore } from "../../../../../helper/helper.js";

function DocumentDetailTable({ data }) {
  const {
    handleSearchValueChange,
    isLoading,
    currentData,
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    currentPage,
  } = useDocumentDetailTable({ data });
  const renderFirstCell = useCallback((obj) => {
    if (obj) {
      return (
        <div className={styles.firstCellFlex}>
          <div className={classNames(styles.firstCellInfo, "openSans")}>
            <span className={styles.productName}>
              {removeUnderScore(obj?.name)}
            </span>{" "}
            <br />
          </div>
        </div>
      );
    }
    return null;
  }, []);

  const renderStatus = useCallback((status) => {
    return <StatusPill status={status} />;
  }, []);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "document",
        label: "DOCUMENT",
        sortable: false,
        render: (temp, all) => <div>{renderFirstCell(all)}</div>,
      },
      {
        key: "type",
        label: "TYPE",
        sortable: false,
        render: (value, all) => (
          <div>
            {all?.is_post_joining === false
              ? "Pre-onboarding"
              : all?.is_post_joining === true
                ? "Post-onboarding"
                : "N/A"}
          </div>
        ),
      },
      {
        key: "file",
        label: "FILE",
        sortable: false,
        render: (value, all) => (
          <div>
            {all?.files?.length ? (
              all.files.map((f, idx) => (
                <span key={idx}>
                  <a
                    key={idx}
                    href={f}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      marginRight: "8px",
                      color: "#2896E9",
                      maxWidth: "250px",
                    }}
                  >
                    View File{all.files.length > 1 ? idx + 1 : ""}
                  </a>
                  {idx < all.files.length - 1 && <span>, </span>}
                </span>
              ))
            ) : (
              <>-</>
            )}
          </div>
        ),
      },
      {
        key: "status",
        label: "STATUS",
        sortable: false,
        render: (value, all) => (
          <div>{renderStatus(removeUnderScore(all?.verificationStatus))}</div>
        ),
      },
      {
        key: "remarks",
        label: "REMARKS",
        sortable: false,
        render: (value, all) => <div>{all?.remarks || "N/A"}</div>,
      },
    ];
  }, [renderStatus, renderFirstCell]);
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]);
  return (
    <div className={styles.brandWiseContainer}>
      <div style={{ width: "100%" }}>
        <div className={styles.header}>
          <div>
            <span className={styles.title}>{`Document Details`}</span>
          </div>
        </div>
        <div>
          <FilterComponent
            is_progress={isLoading}
            filters={[]}
            handleSearchValueChange={handleSearchValueChange}
          />
        </div>
        <DataTables
          {...tableData.datatable}
          {...tableData.datatableFunctions}
        />
      </div>
    </div>
  );
}

export default DocumentDetailTable;
